var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Form',{attrs:{"title":"Your Main Business Logo","icon":"image"}},[_c('ImageGallery',{attrs:{"object-id":_vm.branch.BusinessBranchId,"object-type":_vm.logoImageAttachType,"fileAttachmentType":_vm.logoImageAttachmentType,"limit":1,"altText":_vm.branch.TradingName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }